import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-4024de65")

_pushScopeId("data-v-4024de65")
const _hoisted_1 = { class: "kn-page" }
const _hoisted_2 = { class: "p-d-flex p-flex-column kn-flex" }
const _hoisted_3 = {
  id: "input-container",
  class: "p-d-flex p-flex-column kn-flex"
}
const _hoisted_4 = { class: "p-fluid p-formgrid p-grid p-m-1" }
const _hoisted_5 = { class: "p-float-label p-col" }
const _hoisted_6 = {
  for: "endDate",
  class: "kn-material-input-label"
}
const _hoisted_7 = { class: "p-float-label p-col" }
const _hoisted_8 = {
  for: "endDate",
  class: "kn-material-input-label"
}
const _hoisted_9 = { class: "p-field p-float-label p-col" }
const _hoisted_10 = {
  for: "eventModel",
  class: "kn-material-input-label"
}
const _hoisted_11 = { class: "table-header p-d-flex p-ai-center" }
const _hoisted_12 = {
  id: "search-container",
  class: "p-input-icon-left p-mr-3"
}
const _hoisted_13 = /*#__PURE__*/_createVNode("i", { class: "pi pi-search" }, null, -1)
const _hoisted_14 = { id: "noDatasetsFound" }
const _hoisted_15 = { class: "kn-truncated" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ProgressSpinner = _resolveComponent("ProgressSpinner")
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_Calendar = _resolveComponent("Calendar")
  const _component_Dropdown = _resolveComponent("Dropdown")
  const _component_Button = _resolveComponent("Button")
  const _component_Card = _resolveComponent("Card")
  const _component_InputText = _resolveComponent("InputText")
  const _component_Column = _resolveComponent("Column")
  const _component_DataTable = _resolveComponent("DataTable")
  const _directive_tooltip = _resolveDirective("tooltip")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_ProgressSpinner, {
          key: 0,
          class: "kn-progress-spinner",
          "data-test": "progress-spinner"
        }))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--primary" }, {
        start: _withId(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('managers.eventsManagement.title')), 1)
        ]),
        _: 1
      }),
      _createVNode("div", _hoisted_3, [
        _createVNode(_component_Card, { class: "p-m-2 events-input-card" }, {
          content: _withId(() => [
            _createVNode("form", _hoisted_4, [
              _createVNode("div", _hoisted_5, [
                _createVNode(_component_Calendar, {
                  ref: "test",
                  id: "startDate",
                  class: "kn-material-input",
                  modelValue: _ctx.startDate,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.startDate = $event)),
                  showIcon: true,
                  onDateSelect: _ctx.setFocusOnSearchButton
                }, null, 8, ["modelValue", "onDateSelect"]),
                _createVNode("label", _hoisted_6, _toDisplayString(_ctx.$t('kpi.targetDefinition.startDate')), 1)
              ]),
              _createVNode("div", _hoisted_7, [
                _createVNode(_component_Calendar, {
                  id: "endDate",
                  class: "kn-material-input",
                  modelValue: _ctx.endDate,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.endDate = $event)),
                  showIcon: true,
                  onDateSelect: _ctx.setFocusOnSearchButton
                }, null, 8, ["modelValue", "onDateSelect"]),
                _createVNode("label", _hoisted_8, _toDisplayString(_ctx.$t('kpi.targetDefinition.endDate')), 1)
              ]),
              _createVNode("span", _hoisted_9, [
                _createVNode(_component_Dropdown, {
                  id: "eventModel",
                  class: "kn-material-input",
                  modelValue: _ctx.selectedEventModel,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.selectedEventModel = $event)),
                  options: _ctx.eventModel,
                  onChange: _ctx.setFocusOnSearchButton
                }, null, 8, ["modelValue", "options", "onChange"]),
                _createVNode("label", _hoisted_10, _toDisplayString(_ctx.$t('managers.eventsManagement.eventModel')), 1)
              ]),
              _createVNode(_component_Button, {
                ref: "search-button",
                id: "search-button",
                icon: "pi pi-search",
                class: "p-button-text kn-button thirdButton",
                onClick: _ctx.onSearchClicked,
                "data-test": "search-button"
              }, null, 8, ["onClick"])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_Card, {
          class: "domainCard",
          style: {"height":"calc(100vh - 125px)"}
        }, {
          content: _withId(() => [
            _createVNode(_component_DataTable, {
              class: "p-datatable-sm kn-table",
              first: _ctx.first,
              "onUpdate:first": _cache[5] || (_cache[5] = ($event: any) => (_ctx.first = $event)),
              value: _ctx.events,
              dataKey: "id",
              paginator: true,
              lazy: true,
              totalRecords: _ctx.lazyParams.size,
              paginatorTemplate: "CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink",
              currentPageReportTemplate: _ctx.$t('common.table.footer.paginated', { first: '{first}', last: '{last}', totalRecords: '{totalRecords}' }),
              rows: 20,
              responsiveLayout: "stack",
              breakpoint: "960px",
              scrollable: true,
              scrollHeight: "flex",
              stripedRows: true,
              filters: _ctx.filters,
              "onUpdate:filters": _cache[6] || (_cache[6] = ($event: any) => (_ctx.filters = $event)),
              globalFilterFields: _ctx.globalFilterFields,
              onPage: _cache[7] || (_cache[7] = ($event: any) => (_ctx.onPage($event)))
            }, {
              header: _withId(() => [
                _createVNode("div", _hoisted_11, [
                  _createVNode("span", _hoisted_12, [
                    _hoisted_13,
                    _createVNode(_component_InputText, {
                      class: "kn-material-input",
                      modelValue: _ctx.filters['global'].value,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.filters['global'].value = $event)),
                      placeholder: _ctx.$t('common.search')
                    }, null, 8, ["modelValue", "placeholder"])
                  ])
                ])
              ]),
              loading: _withId(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('common.info.dataLoading')), 1)
              ]),
              empty: _withId(() => [
                _createVNode("div", _hoisted_14, _toDisplayString(_ctx.$t('common.info.noDataFound')), 1)
              ]),
              default: _withId(() => [
                _createVNode(_component_Column, {
                  field: "user",
                  class: "kn-truncated",
                  header: _ctx.$t('managers.eventsManagement.user'),
                  sortable: true
                }, null, 8, ["header"]),
                _createVNode(_component_Column, {
                  field: "formattedDate",
                  class: "kn-truncated",
                  header: _ctx.$t('cron.date'),
                  sortable: true
                }, null, 8, ["header"]),
                _createVNode(_component_Column, {
                  field: "type",
                  class: "kn-truncated",
                  header: _ctx.$t('common.type'),
                  sortable: true
                }, null, 8, ["header"]),
                _createVNode(_component_Column, {
                  header: _ctx.$t('common.description'),
                  class: "kn-truncated",
                  sortable: true
                }, {
                  body: _withId((slotProps) => [
                    _withDirectives(_createVNode("span", _hoisted_15, [
                      _createTextVNode(_toDisplayString(slotProps.data.desc), 1)
                    ], 512), [
                      [
                        _directive_tooltip,
                        slotProps.data.desc,
                        void 0,
                        { top: true }
                      ]
                    ])
                  ]),
                  _: 1
                }, 8, ["header"])
              ]),
              _: 1
            }, 8, ["first", "value", "totalRecords", "currentPageReportTemplate", "filters", "globalFilterFields"])
          ]),
          _: 1
        })
      ])
    ])
  ]))
})